// extracted by mini-css-extract-plugin
export var sliderDots = "styles-module--sliderDots--dW+68";
export var slickActive = "styles-module--slick-active--dHBzq";